<template>
  <v-btn text color="info" @click="save" :disabled="!savable" :loading="saving"
    >Speichern
  </v-btn>
</template>

<script>
import { defineComponent } from "vue";
import { foreign, gym1OK, mixedGradesOK } from "common/utils/finance.js";

export default defineComponent({
  data() {
    return {
      saving: false,
    };
  },
  props: {
    item: {},
    tolerance: false,
    valid: false,
    distribute: { type: Boolean, default: false },
  },
  computed: {
    isNew() {
      return !this.item.id;
    },
    gym1OK() {
      return gym1OK(this.item);
    },
    mixedGradesOK() {
      return mixedGradesOK(this.item);
    },
    foreign() {
      return foreign(this.item);
    },
    savable() {
      return (
        this.item &&
        this.valid &&
        ((this.foreign && this.item.amountForeign > 0) ||
          (!this.foreign && this.item.amount > 0)) &&
        this.item.description &&
        (this.item.details.length > 0 || this.item.nodetails) &&
        this.item.account &&
        this.item.payee &&
        (this.tolerance || this.item.nodetails) &&
        this.mixedGradesOK &&
        this.gym1OK
      );
    },
  },
  methods: {
    async save() {
      this.saving = true;

      // deep copy
      const data = JSON.parse(JSON.stringify(this.item));
      // replace person-json with person-id
      data.details.forEach((detail) => (detail.person = detail.person.id));
      // remove unused currency
      if (this.foreign && !this.distribute) {
        data.details.forEach((detail) => delete detail.amount);
        delete data.amount;
      } else {
        data.details.forEach((detail) => delete detail.amountForeign);
        delete data.amountForeign;
      }

      let newId = this.item.id;
      if (this.isNew) {
        const result = await this.apiPost({
          resource: "finance/invoice",
          data: data,
        });
        newId = result.id;
      } else {
        await this.apiPut({
          resource: "finance/invoice",
          id: this.item.id,
          data: data,
        });
      }
      this.saving = false;

      this.$emit("saved", newId);
    },
  },
});
</script>
